import { schema } from "normalizr";

import { User, NUser } from "./auth";
import { File, NFile } from "./files";
import { TranslatableMap } from "./localisation";
import { Album, NAlbum } from "./music";

interface Bundle {
    id: number;
    attrs: {
        [key: string]: any;
    };
    errors: {
        [key: string]: string;
    };
    status_name: string;
    metadata_file_id: number;
    bundle_file_id: number;
    album_id: number;
    user_id: number;
    organisation_id: number;
    created_at: Date;
    updated_at: Date;
    status: BundleStatus;
    metadata_file: File;
    bundle_file: File;
    album: Album;
    user: User;
}

interface BundleStatus {
    name: string;
    label: TranslatableMap;
}

const NBundleStatus = new schema.Entity("bundleStatuses", {}, {
    idAttribute: "name",
});

const NBundle = new schema.Entity("bundles", {
    status: NBundleStatus,
    metadata_file: NFile,
    bundle_file: NFile,
    album: NAlbum,
    user: NUser,
});

interface UploadNormalisedEntities {
    bundles?: {
        [key: string]: Bundle;
    };
    bundleStatuses?: {
        [key: string]: BundleStatus,
    };
}

export type {
    Bundle,
    BundleStatus,
};
export {
    NBundleStatus,
    NBundle,
    UploadNormalisedEntities,
};
